import {useMutation} from "@tanstack/react-query";

export const findPwByPhone = async ({loginId, name, phoneNumber, authNumber, timeStamp}) => {
    const response = await fetch('/api/find-pw', {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({loginId, name, phoneNumber, authNumber, timeStamp }),
    });

    const data = await response.json();
    if (!response.ok) {
        throw new Error(data.message || "비밀번호 찾기에 실패했습니다.");
    }

    return data;
};

// 실제 인증번호 발송 요청 api
export const verifyPhone = async ({phoneNumber}) => {
    /* 회원 있을 시 문자인증 보내는 api 사용 */
    const response = await fetch("/api/members/phone/certification/duplicate", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ phoneNumber }),
    });

    const data = await response.json();
    console.log(response.ok ? "전화번호 인증 요청 성공" : "전화번호 인증 요청 실패", data);
    if (data.result === "noUser") {
        throw new Error(data.message || "가입되지 않은 회원입니다.");
    }
    if (!response.ok) {
        throw new Error(data.message || "전화번호 인증 요청에 실패했습니다.");
    }
    return data;
};

// verifyPhoneMutation 설정. 인증번호 발송 요청 시 사용
export const useVerifyPhoneMutation = () => {
    return useMutation({
        mutationFn: verifyPhone,
        onSuccess: (data) => {

            if (data.result === "noUser") {
                throw new Error(data.message || "가입되지 않은 회원입니다.");
            }
            console.log("전화번호 인증 요청 성공:", data);
        },
        onError: (error) => {
            console.error("전화번호 인증 요청 실패:", error);
            throw error;
        },
    });
};

// ID 찾기 mutation 설정, 전화번호로 ID 찾기 시 사용
export const useFindPwByPhoneMutation = () => {
    return useMutation({
        mutationFn: findPwByPhone,
        onSuccess: (data) => {
            console.log("PW 찾기 성공:", data);

            return data;
        },
        onError: (error) => {
            console.error("PW 찾기 실패:", error);
            throw error;
        },
    });
};

// 비밀번호 변경 api
export const resetPassword = async ({loginId, newPassword, newPasswordConfirm}) => {
    const response = await fetch("/api/modify-pw", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ loginId, newPassword, newPasswordConfirm }),
    });

    const data = await response.json();

    if (!response.ok) {
        throw new Error(data.message || "비밀번호 변경에 실패했습니다.");
    }

    return data;
};

// resetPasswordMutation 설정. 비밀번호 변경 시 사용
export const useResetPasswordMutation = () => {
    return useMutation({
        mutationFn: resetPassword,
        onSuccess: (data) => {
            console.log("비밀번호 변경 성공:", data);

            return data;
        },
        onError: (error) => {
            console.error("비밀번호 변경 실패:", error);
            throw error;
        },
    });
};
